import { http, param } from '../../utils/http'
import conf from '../../config'

export const API_ROOT = `${conf.OPEN_FDA_BASE_URL}`
export const API_BASE = `${conf.API_URL}`

const fdaServices = {
    getAllFdaRecalls(payload) {
        var arr = [
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'searchQuery', val: payload.search ? payload.search.trim() : '' },
            { query: 'filterModel', val: payload.filterModel ? encodeURIComponent(JSON.stringify(payload.filterModel)) : null },
            { query: 'recallType', val: payload.recall_type ? payload.recall_type : ''},
            {query: 'fields', val: payload.fields ? encodeURIComponent(payload.fields) : null}
        ]
        return http.get(`${API_BASE}/notisphere/fda/recalls${param(arr)}`).then(resp => {
            return resp
        })
    },
    exportAllFdaRecalls(payload) {
        var query_params = param([
            { query: 'sort_field', val: payload.sortField },
            { query: 'sort_direction', val: payload.sortDirection },
            { query: 'search_query', val: payload.search_query ? payload.search_query.trim() : '' },
            { query: 'filter_model', val: payload.filter_model ? encodeURIComponent(JSON.stringify(payload.filter_model)) : null },
            { query: 'email', val: payload.email ? payload.email : '' },
            { query: 'recall_type', val: payload.recall_type ? payload.recall_type : ''},
            { query: 'fields', val: payload.fields ? encodeURIComponent(payload.fields) : null}
        ])
        return http.get(`${API_ROOT}/exportRecalls${query_params}`).then(resp => {
            return resp
        })
    },
    getFdaRecall(objectId, recall_type) {
        return http.get(`${API_ROOT}/getrecall?objectId=${objectId}&recall_type=${recall_type}`).then(resp => {
            return resp
        })
    },
    getFdaRecallMetaData(recall_type) {
        return http.get(`${API_ROOT}/getmeta?recall_type=${recall_type}`).then(resp => {
            return resp
        })
    },
    updateFdaRecall(payload) {
        return http.put(`${API_ROOT}/getrecall`, payload).then(resp => {
            return resp
        })
    },
    getUploadedFdaDeviceFilesStatus() {
        return http.get(`${API_ROOT}/getFileStatus`).then(resp => {
            return resp.data
        })
    },
    uploadDeviceExcelFile(file, sourcePage) {
        const formData = new FormData()
        formData.append('file', file)
        return http.post(`${API_BASE}/notisphere/fda/upload-device-file`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-Notisphere-Source': sourcePage || 'openfda-devices'
            },
        }).then(resp => {
            return resp
        })
    }
}
export default fdaServices